import { createSelector } from 'reselect'
import { IAdminWelcomeEmailState } from 'store/entities/adminWelcomeEmail/interface'
import { Record } from 'immutable'

export const getAdminWelcomeEmail = (state: any): Record<IAdminWelcomeEmailState> => state.get('adminWelcomeEmail')

export const getAdminWelcomeEmailData = createSelector(getAdminWelcomeEmail, welcomeEmail => welcomeEmail.get('data'))

export const getAdminWelcomeEmailDataFilled = createSelector(
  getAdminWelcomeEmailData,
  welcomeEmail => !!welcomeEmail.get('text')
)

export const getAdminWelcomeEmailPending = createSelector(getAdminWelcomeEmail, adminEmail => adminEmail.get('pending'))

export const getAdminWelcomeEmailPendingGet = createSelector(getAdminWelcomeEmailPending, pending => pending.get('get'))

export const getAdminWelcomeEmailPendingSave = createSelector(getAdminWelcomeEmailPending, pending =>
  pending.get('save')
)
